// wisa-tv entry point — bare-minimum bootstrap.
// No global providers, no auth, no analytics. The TV display is purely
// read-only and should boot as fast as possible.
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Global recovery: if anything throws to top-level and React unmounts,
// reload the page after a short cooldown so the kiosk self-heals.
window.addEventListener('error', () => {
  console.warn('[wisa-tv] Window error caught — scheduling reload in 30s as safety net');
  setTimeout(() => location.reload(), 30000);
});
window.addEventListener('unhandledrejection', (e) => {
  console.warn('[wisa-tv] Unhandled promise rejection:', e.reason);
});

// Page-Reload Timer fallback — even if everything else fails, force a
// reload every 30 min so the kiosk can never be stuck longer than that.
// This is independent of Fully Kiosk's own auto-reload settings — defence
// in depth.
setTimeout(() => {
  console.log('[wisa-tv] 30-min watchdog reload firing');
  location.reload();
}, 30 * 60 * 1000);
